import { createIcon } from '../createIcon';

export const ResourcePoolIconConfig = {
  name: 'ResourcePoolIcon',
  height: 1024,
  width: 1096,
  svgPath: 'M1020.571 804.571v91.429c0 30.171-24.686 54.857-54.629 54.857h-838.171c-29.943 0-54.629-24.686-54.629-54.857v-693.486c0-30.171 24.686-54.857 54.629-54.857h18.514l0.914-1.143v-219.429h803.886v219.429l0.686 1.143h14.171c30.171 0 54.629 24.686 54.629 54.857v64.229l1.143 2.057v535.771h-1.143zM293.029 0h-72.914v146.286h72.914v-146.286zM438.629 0h-72.914v146.286h72.914v-146.286zM584.457 0h-72.914v146.286h72.914v-146.286zM730.286 0h-72.914v146.286h72.914v-146.286zM800.914 660.571v0h-73.143v-73.143h72.914v-73.143h-72.914v-73.143h72.914v-73.143h-72.914v-73.143h-72.914v73.143h-72.914v-73.143h-72.914v73.143h-72.914v-73.143h-72.686v73.143h-72.914v73.143h72.914v73.143h-72.914v73.143h72.914v73.143h-72.914v73.143h72.914v73.143h72.914v-73.143h72.914v73.143h72.914v-73.143h72.914v73.143h72.914v-73.143h72.914v-73.143zM875.886 0h-72.914v146.286h72.914v-146.286z',
  yOffset: 64,
  xOffset: 0,
  transform: 'rotate(180 0 512) scale(-1 1)'
};

export const ResourcePoolIcon = createIcon(ResourcePoolIconConfig);

export default ResourcePoolIcon;